var map = {
	"./aluno/aluno.module": [
		"./src/app/layout/aluno/aluno.module.ts",
		"default~aluno-aluno-module~aula-aula-module~cadastro-completo-cadastro-completo-module~cadastro-simp~2080ab12",
		"default~aluno-aluno-module~layout-layout-module~professor-professor-module",
		"common",
		"aluno-aluno-module"
	],
	"./apostila/apostila.module": [
		"./src/app/layout/apostila/apostila.module.ts",
		"apostila-apostila-module"
	],
	"./aula/aula.module": [
		"./src/app/layout/aula/aula.module.ts",
		"default~aula-aula-module~feed-feed-module~flash-card-flash-card-module~perfil-perfil-module~podcast-~dcd430a2",
		"default~aluno-aluno-module~aula-aula-module~cadastro-completo-cadastro-completo-module~cadastro-simp~2080ab12",
		"default~aula-aula-module~flash-card-flash-card-module",
		"common",
		"aula-aula-module"
	],
	"./cadastro-completo/cadastro-completo.module": [
		"./src/app/layout-loja/cadastro-completo/cadastro-completo.module.ts",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~d1cb685f",
		"default~aluno-aluno-module~aula-aula-module~cadastro-completo-cadastro-completo-module~cadastro-simp~2080ab12",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~0b297357",
		"common",
		"cadastro-completo-cadastro-completo-module"
	],
	"./cadastro-simplificado/cadastro-simplificado.module": [
		"./src/app/cadastro-simplificado/cadastro-simplificado.module.ts",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~d1cb685f",
		"default~aluno-aluno-module~aula-aula-module~cadastro-completo-cadastro-completo-module~cadastro-simp~2080ab12",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~0b297357",
		"common",
		"cadastro-simplificado-cadastro-simplificado-module"
	],
	"./feed/feed.module": [
		"./src/app/layout/feed/feed.module.ts",
		"default~aula-aula-module~feed-feed-module~flash-card-flash-card-module~perfil-perfil-module~podcast-~dcd430a2",
		"common",
		"feed-feed-module"
	],
	"./flash-card/flash-card.module": [
		"./src/app/layout/flash-card/flash-card.module.ts",
		"default~aula-aula-module~feed-feed-module~flash-card-flash-card-module~perfil-perfil-module~podcast-~dcd430a2",
		"default~aula-aula-module~flash-card-flash-card-module",
		"common",
		"flash-card-flash-card-module"
	],
	"./identificacao-aluno/identificacao-aluno.module": [
		"./src/app/layout-loja/identificacao-aluno/identificacao-aluno.module.ts",
		"common",
		"identificacao-aluno-identificacao-aluno-module"
	],
	"./layout-loja/layout-loja.module": [
		"./src/app/layout-loja/layout-loja.module.ts",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~d1cb685f",
		"common",
		"layout-loja-layout-loja-module"
	],
	"./layout-trial/layout-trial.module": [
		"./src/app/layout-trial/layout-trial.module.ts",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~d1cb685f",
		"common",
		"layout-trial-layout-trial-module"
	],
	"./layout/layout.module": [
		"./src/app/layout/layout.module.ts",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~d1cb685f",
		"default~aluno-aluno-module~layout-layout-module~professor-professor-module",
		"common",
		"layout-layout-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~d1cb685f",
		"default~login-login-module~nova-senha-nova-senha-module~recuperacao-senha-recuperacao-senha-module",
		"common",
		"login-login-module"
	],
	"./loja/loja.module": [
		"./src/app/layout-loja/loja/loja.module.ts",
		"common",
		"loja-loja-module"
	],
	"./nova-senha/nova-senha.module": [
		"./src/app/nova-senha/nova-senha.module.ts",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~d1cb685f",
		"default~login-login-module~nova-senha-nova-senha-module~recuperacao-senha-recuperacao-senha-module",
		"common",
		"nova-senha-nova-senha-module"
	],
	"./pedido-finalizado/pedido-finalizado.module": [
		"./src/app/layout-loja/pedido-finalizado/pedido-finalizado.module.ts",
		"common",
		"pedido-finalizado-pedido-finalizado-module"
	],
	"./perfil/perfil.module": [
		"./src/app/layout/perfil/perfil.module.ts",
		"default~aula-aula-module~feed-feed-module~flash-card-flash-card-module~perfil-perfil-module~podcast-~dcd430a2",
		"common",
		"perfil-perfil-module"
	],
	"./plano/plano.module": [
		"./src/app/layout-loja/plano/plano.module.ts",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~d1cb685f",
		"common",
		"plano-plano-module"
	],
	"./plataforma-trial/plataforma-trial.module": [
		"./src/app/layout-trial/plataforma-trial/plataforma-trial.module.ts",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~d1cb685f",
		"common",
		"plataforma-trial-plataforma-trial-module"
	],
	"./podcast/podcast.module": [
		"./src/app/layout/podcast/podcast.module.ts",
		"default~aula-aula-module~feed-feed-module~flash-card-flash-card-module~perfil-perfil-module~podcast-~dcd430a2",
		"default~aluno-aluno-module~aula-aula-module~cadastro-completo-cadastro-completo-module~cadastro-simp~2080ab12",
		"common",
		"podcast-podcast-module"
	],
	"./professor/professor.module": [
		"./src/app/layout/professor/professor.module.ts",
		"default~aluno-aluno-module~layout-layout-module~professor-professor-module",
		"common",
		"professor-professor-module"
	],
	"./prova/prova.module": [
		"./src/app/layout/prova/prova.module.ts",
		"default~aula-aula-module~feed-feed-module~flash-card-flash-card-module~perfil-perfil-module~podcast-~dcd430a2",
		"default~aluno-aluno-module~aula-aula-module~cadastro-completo-cadastro-completo-module~cadastro-simp~2080ab12",
		"common",
		"prova-prova-module"
	],
	"./recuperacao-senha/recuperacao-senha.module": [
		"./src/app/recuperacao-senha/recuperacao-senha.module.ts",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~d1cb685f",
		"default~login-login-module~nova-senha-nova-senha-module~recuperacao-senha-recuperacao-senha-module",
		"common",
		"recuperacao-senha-recuperacao-senha-module"
	],
	"./selecao-plano/selecao-plano.module": [
		"./src/app/selecao-plano/selecao-plano.module.ts",
		"default~cadastro-completo-cadastro-completo-module~cadastro-simplificado-cadastro-simplificado-modul~d1cb685f",
		"default~aula-aula-module~feed-feed-module~flash-card-flash-card-module~perfil-perfil-module~podcast-~dcd430a2",
		"common",
		"selecao-plano-selecao-plano-module"
	],
	"./video/video.module": [
		"./src/app/video/video.module.ts",
		"common",
		"video-video-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;